import MuiCheckbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { CheckboxProps } from './Checkbox.props';
import { StyledCheckboxLabel } from './Checkbox.styles';

const Checkbox = ({ checked, error = false, helperText, label, onChange, ...props }: CheckboxProps) => (
  <Stack spacing={0.5}>
    <StyledCheckboxLabel
      hasError={error}
      control={<MuiCheckbox checked={checked} onChange={event => onChange?.(event.target.checked)} {...props} />}
      label={label}
    />
    {helperText ? (
      <Typography color={error ? 'error.main' : 'text.secondary'} variant="caption">
        {helperText}
      </Typography>
    ) : null}
  </Stack>
);

export default Checkbox;
